import React from 'react';
import styled from 'styled-components';

import {getDirectionStyles} from '../../utils/ThemeUtils';
import MyOverallHighlightsPanel from './my-overall-highlights/MyOverallHighlightsPanel';
import MyTopPerformingGamesPanel from './my-top-performing-games/MyTopPerformingGamesPanel';
import MyTop10GamesPanel from './my-top-10-games/MyTop10GamesPanel';

export const SidebarContainer = styled.div`
    width: 100%;

    & > *:not(:first-child) {
        margin-top: ${p => p.theme.muiTheme.spacing(10)}px;
    }

    ${p => p.theme.muiTheme.breakpoints.up('flg')} {
        width: 374px;
        padding: ${p =>
            getDirectionStyles(p.theme.muiTheme.direction)(
                p.theme.muiTheme.spacing(0, 0, 0, 7),
                p.theme.muiTheme.spacing(0, 7, 0, 0)
            )};
    }
    ${p => p.theme.muiTheme.breakpoints.up('xl')} {
        min-width: 512px;
        padding: ${p =>
            getDirectionStyles(p.theme.muiTheme.direction)(
                p.theme.muiTheme.spacing(0, 0, 0, 10),
                p.theme.muiTheme.spacing(0, 10, 0, 0)
            )};
    }
`;

const SidebarSection = styled.div`
    display: flex;
    flex-direction: column;

    & > * {
        margin-top: ${p => p.theme.muiTheme.spacing(10)}px;
    }

    ${p => p.theme.muiTheme.breakpoints.up('fmd')} {
        flex-direction: row;

        & > *:first-child {
            margin: ${p =>
                getDirectionStyles(p.theme.muiTheme.direction)(
                    p.theme.muiTheme.spacing(10, 7, 0, 0),
                    p.theme.muiTheme.spacing(10, 0, 0, 7)
                )};
        }
    }
    ${p => p.theme.muiTheme.breakpoints.up('flg')} {
        flex-direction: column;

        & > *:first-child {
            margin: 0;
        }
    }
`;

export const Sidebar = () => (
    <SidebarContainer>
        <SidebarSection>
            <MyOverallHighlightsPanel />
            <MyTopPerformingGamesPanel />
        </SidebarSection>
        <MyTop10GamesPanel />
    </SidebarContainer>
);
